import React from "react";
import { useSecurity } from '../../hooks/useSecurity';
import { useAccountDeletion } from '../../hooks/useAccountDeletion';
import DeleteAccountModal from './DeleteAccountModal';

export default function SecurityTab({
  showPasswordFields, passwordData, passwordError, passwordSaving,
  handleChangePassword, handlePasswordChange, handleSavePassword, handleCancelPassword,
  showSavedToast,
}) {
  const { signOutOthers, signingOut, signOutError } = useSecurity({ showSavedToast });
  const {
    showConfirm, openConfirm, closeConfirm,
    password, setPassword, confirmText, setConfirmText,
    deleting, error: deleteError, handleDelete,
  } = useAccountDeletion();

  return (
    <div className="profile-content">
      <div className="profile-header">
        <h1>Security</h1>
        <p className="profile-header-subtitle">Manage your password, sessions, and account.</p>
      </div>

      <div className="profile-main-content">
        <div className="profile-fields-section">
          <div className="settings-section">
            <h2 className="settings-section-title">Password</h2>
            {!showPasswordFields ? (
              <div className="password-field">
                <input type="password" value="••••••••" className="profile-input profile-input-disabled" disabled readOnly />
                <button className="change-btn" onClick={handleChangePassword}>Change</button>
              </div>
            ) : (
              <div className="password-change-fields">
                <input
                  type="password"
                  placeholder="Old password"
                  value={passwordData.oldPassword}
                  onChange={(e) => handlePasswordChange('oldPassword', e.target.value)}
                  className="password-change-input"
                />
                <input
                  type="password"
                  placeholder="New password"
                  value={passwordData.newPassword}
                  onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                  className={`password-change-input ${!passwordData.oldPassword ? 'password-input-disabled' : ''}`}
                  disabled={!passwordData.oldPassword}
                />
                <input
                  type="password"
                  placeholder="Confirm new password"
                  value={passwordData.confirmPassword}
                  onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                  className={`password-change-input ${!passwordData.oldPassword ? 'password-input-disabled' : ''}`}
                  disabled={!passwordData.oldPassword}
                />
                {passwordError && (
                  <div style={{
                    marginTop: 8,
                    padding: '8px 12px',
                    background: '#fef2f2',
                    border: '1px solid #fecaca',
                    borderRadius: 8,
                    color: '#b91c1c',
                    fontSize: 13,
                    lineHeight: 1.4,
                  }}>
                    {passwordError}
                  </div>
                )}
                <div className="password-change-buttons">
                  <button className="password-cancel-btn" onClick={handleCancelPassword} disabled={passwordSaving}>
                    Cancel
                  </button>
                  <button className="password-save-btn" onClick={handleSavePassword} disabled={passwordSaving}>
                    {passwordSaving ? 'Saving…' : 'Save'}
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="settings-section">
            <h2 className="settings-section-title">Sessions</h2>
            <div className="field-content">
              <span className="field-value">Sign out of NOVAS on every other device or browser.</span>
              <button className="edit-btn" onClick={signOutOthers} disabled={signingOut}>
                {signingOut ? 'Signing out…' : 'Sign out of all other devices'}
              </button>
            </div>
            {signOutError && (
              <p style={{ marginTop: 8, fontSize: 13, color: '#b91c1c' }}>{signOutError}</p>
            )}
          </div>

          <div className="settings-section danger">
            <h2 className="settings-section-title">Danger zone</h2>
            <div className="field-content">
              <span className="field-value">
                Permanently delete your account, students, lessons and all related data.
              </span>
              <button className="danger-btn" onClick={openConfirm}>
                Delete account
              </button>
            </div>
          </div>
        </div>
      </div>

      <DeleteAccountModal
        isOpen={showConfirm}
        onCancel={closeConfirm}
        onConfirm={handleDelete}
        password={password}
        setPassword={setPassword}
        confirmText={confirmText}
        setConfirmText={setConfirmText}
        deleting={deleting}
        error={deleteError}
      />
    </div>
  );
}
